import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseStore, HomeModel, InitModel, AppComponentModel, WSAppSource } from './shared';
import { StoreService, WebStoreSettings } from './core';
import { HttpService, LoginWebStoreAppModel, LoginService, EndWithSlash } from 'projects/lib-components/src/public_api';
import * as $ from 'jquery';
import { forkJoin, Observable, Subscription } from 'rxjs';

@Component({
  selector: 'web-store-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})

export class AppComponent extends BaseStore implements OnInit, OnDestroy {
  private results: Subscription[] = [];
  public model: AppComponentModel;
  public isLoggedIn: boolean = false;

  constructor(
    private login: LoginService,
    protected store: StoreService,
    protected http: HttpService,
    protected router: Router,
  ) {
    super(store);
  }

  ngOnInit(): void {
    this.router.navigate(['']); // force to empty routing in order to manage F5 refresh
    this.store.ClearDataSession(); // re-initialise session data
    this.model = new AppComponentModel();
    this.loginApp();
  }

  ngOnDestroy(): void {
    this.results.forEach((subscription: Subscription) => subscription.unsubscribe());
  }

  changeLanguage(lan: string): void {
    this.store.showSplash(false);
    this.store.AppParams.culture = lan;
    this.http.getHttp<InitModel>(`${EndWithSlash(this.store.AppParams.apiUrl)}api/initapp/V2/INIT/ALL`).subscribe((data: InitModel): void => {
      if (!data.HasError) {
        this.store.Trad = data.TranslationLib;
        this.store.showSplash(false);
        this.initData();
      }
    });
  }

  closeAlert(): void {
    this.store.closeModal();
  }

  private loginApp(): void {
    if (!this.store.InitOk) {
      alert(`ERREUR D'INITIALISATION DE L'APPLICATION`); // query string params not found
      this.store.openPage('HME');
      return;
    }

    const model: LoginWebStoreAppModel = new LoginWebStoreAppModel();
    model.module = this.store.begin.mode;
    model.sample = this.store.begin.sample;
    model.start = this.store.begin.siteUrl;

    const appUrl: string = window.location.href.split('?')[0];
    const apiUrl: string = this.store.begin.apiUrl;
    this.results.push(this.login.loginWebStore(model, appUrl, apiUrl).subscribe((data: boolean): void => {
      if (!data) {
        alert('Application login failure');
        this.store.InitOk = false;
        this.store.openPage('HME');
        return;
      }

      const urlCss: string = `${location.protocol}//${location.hostname}/WebStore/DATA/css/${this.store.AppParams.dbname}/default.css`
      console.log(urlCss);
      $('#theme').attr('href', urlCss);
      this.isLoggedIn = true;
      this.initData();
    }));
  }

  private initData(): void {
    const call1: Observable<HomeModel> = this.http.getHttp<HomeModel>(`${EndWithSlash(this.store.AppParams.apiUrl)}api/home/getData/V2/INITDATA1/0`);
    const call2: Observable<HomeModel> = this.http.getHttp<HomeModel>(`${EndWithSlash(this.store.AppParams.apiUrl)}api/home/getData/V2/INITDATA2/0`);
    this.results.push(forkJoin([call1, call2]).subscribe((results: [HomeModel, HomeModel]) => {
      const m1: HomeModel = results[0];
      const m2: HomeModel = results[1];

      const source: WSAppSource = this.store.begin.access === 'PORTAIL' ? WSAppSource.EXTRANET : WSAppSource.PUBLIC;
      this.store.AppSettings = new WebStoreSettings(
        source,
        m2.UserRole,
        m2.ListApprenantsOrderedByClients,
        m2.ListRHsOrderebByClients
      );

      this.store.countCursus = m1.CountCycles;
      this.store.countStages = m1.CountStages;
      this.store.configModel = m1.Config;
      this.store.stockData('Facebook', m1.Facebook && m1.Facebook !== '' ? m1.Facebook : '#');
      this.store.stockData('Twitter', m1.Twitter && m1.Twitter !== '' ? m1.Twitter : '#');
      this.store.stockData('Linkedin', m1.Linkedin && m1.Linkedin !== '' ? m1.Linkedin : '#');
      this.store.stockData('Viadeo', m1.Viadeo && m1.Viadeo !== '' ? m1.Viadeo : '#');

      this.model.hasCursus = m1.CountCycles > 0;
      this.model.hasStages = m1.CountStages > 0;
      this.model.isAdmin = this.store.begin.isAdmin;

      this.store.openPage('HME');
    }));
  }
}
